import { StyledSuccess } from "./success.styles";

function Success({ message }) {
  return <StyledSuccess>{message}</StyledSuccess>;
}

export default Success;
